@if (!logoLoaded && fallbackIcon) {
    <span [ngClass]="fallbackIcon"></span>
}
@if (competitionLogoUrl) {
    <div [class.logo-circle]="showBackgroundCircle" [class.fallback-color]="fallbackColor" [style.background-color]="logoColor">
        <img
            class="competition-logo"
            ngSrcset="1x, 2x, 3x"
            [class.invisible]="!logoLoaded"
            [height]="36"
            [hidden]="loadingError"
            [ngSrc]="competitionLogoUrl"
            [width]="36"
            (load)="loadLogo()"
            (error)="onLoadingError()" />
    </div>
}
